import { SMALLEST_HEADER_HEIGHT } from "@store/Overrides/Widgets/Header/LogoLinksSearch";

const scrollToId = (id: string) => {
    const body = document.body; // Safari
    const html = document.documentElement; // Chrome, Firefox, IE and Opera

    const idToScrollTo = document.getElementById(id);
    const viewportPosition = idToScrollTo?.getBoundingClientRect().top || 0; // Position within the viewport
    const viewportToDocument = window.scrollY; // Distance between top of viewport and top of document
    const scrollTopPx = viewportPosition + viewportToDocument - SMALLEST_HEADER_HEIGHT;

    body.scrollTop = scrollTopPx;
    html.scrollTop = scrollTopPx;
};

export default scrollToId;
